// extracted by mini-css-extract-plugin
export default {"container":"vUBWRNyjXA2TxE7ZC5h4","wide":"O_8h9tF6lulMVCFweF8k","select-wrapper":"Y_mYX1yt8VKCsOzHIj4q","tall":"VoiNBJJ9kGCMorsEcfD8"};